<template>
  <div class="operateWork">
    <div class="ow_title">
      结果呈现
    </div>
    <div class="img_module">
      <div class="left_button" @click="changImg('reduce')">

      </div>
      <div class="center_box">
        <div class="i_left_module">
          <div class="i_font HuXiaoBo">
            <div>
              改造前
            </div>
          </div>
          <div class="i_img" v-for="(item,index) in imgList" :key="item.beforeImg" v-show="activeIndex===index">
            <img :src="item.beforeImg" alt="">
          </div>
        </div>
        <div class="i_mid_module">
          <div class="mid_img">
            <span class="work_type pangMen">
              改造效果对比
            </span>
          </div>
          <div class="button_list">
            <div class="item_button" v-for="item in list" :key="item">

            </div>
          </div>
        </div>
        <div class="i_right_module">
          <div class="i_img" v-for="(item,index) in imgList" :key="item.workType" v-show="activeIndex===index">
            <img :src="item.afterImg" alt="">
          </div>
          <div class="i_font HuXiaoBo">
            <div>
              改造后
            </div>
          </div>
        </div>
      </div>
      <div class="right_button" @click="changImg('add')"></div>
    </div>
  </div>
</template>

<script>
import jsonData from  '/public/static/js/json/operateManage.json';
export default {
  name: 'operateWork',
  data() {
    return {
      list: [1, 2, 3, 4, 5],
      activeIndex: 0,
      timer: null,
      imgList: []
    }
  },
  mounted() {
   this.imgList = jsonData.resultPresentation;
   this.timer = setInterval(()=>{
      ++this.activeIndex;
      if(this.activeIndex > this.imgList.length - 1) {
        this.activeIndex = 0;
      }
    },5000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    changImg(type) {
      if (type === 'add') {
        if (this.activeIndex + 1 > this.imgList.length - 1) {
          this.activeIndex = 0;
        } else {
          this.activeIndex++;
        }
      } else {
        if (this.activeIndex - 1 === 0) {
          this.activeIndex = this.imgList.length - 1;
        } else {
          this.activeIndex--;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.operateWork {
  height: 100%;
  width: 100%;
  position: relative;
  left: 0;
  top: 0;
  .ow_title {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 30px;
    color: #63F2EF;
    padding-left: 20px;
    font-weight: 600;
  }
  .img_module {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .left_button {
      @include bg-box(100px, 240px, 'left_button.png');
      cursor: pointer;
    }

    .center_box {
      display: flex;

      .i_left_module {
        display: flex;
        flex: 1;
        margin-right: 40px;

        .i_font {

          display: flex;
          align-items: center;
          width: 200px;
          justify-content: center;

          div {
            color: #ffb013;
            font-size: 48px;
            width: 50px;
          }
        }

        .i_img {
          width: 520px;
          height: 320px;
          border: 1px solid #ffb013;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .i_mid_module {
        width: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .mid_img {
          @include bg-box(280px, 260px, 'center_box.png');
          margin-bottom: 20px;
          position: relative;

          .work_type {
            font-size: 48px;
            width: 150px;
            position: absolute;
            left: 52%;
            top: 36%;
            transform: translate(-50%, -50%);
          }
        }

        .button_list {
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;

          .item_button {
            width: 40px;
            height: 8px;
            border-radius: 10px;
            background: #bcc8e6;
            cursor: pointer;
          }
        }

      }

      .i_right_module {
        display: flex;
        flex: 1;
        margin-left: 40px;

        .i_font {
          display: flex;
          align-items: center;
          width: 200px;
          justify-content: center;

          div {
            font-size: 48px;
            width: 50px;
            color: #33c4fd;
          }
        }

        .i_img {
          width: 520px;
          height: 320px;
          border: 1px solid #33c4fd;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .right_button {
      cursor: pointer;
      @include bg-box(100px, 240px, 'right_button.png');
    }
  }
}
</style>
